import { ChangeDetectionStrategy, Component, Input, OnInit, TemplateRef } from '@angular/core';
import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { MOperationsTemplateService } from './operations-template.service';

@Component({
  selector: 'm-operations-template',
  template: `
    <ng-template [ngTemplateOutlet]="outletRef!"></ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MOperationsTemplateComponent implements OnInit {
  @Input() ref = '';

  outletRef: TemplateRef<NzSafeAny> | undefined;

  constructor(private templateService: MOperationsTemplateService) {}

  ngOnInit(): void {
    if (this.ref) {
      this.outletRef = this.templateService.getTemplateRef(this.ref);
    }
  }
}
